"use client";

import { loginClient } from "@/actions/auth/auth_action";
import MyImage from "@/image_layout/my_image";
import { images } from "@/lib/contants";
import Link from "next/link";
import { useActionState, useEffect, useState } from "react";
import { BsFillTriangleFill } from "react-icons/bs";
import { FaEyeSlash, FaRegEye } from "react-icons/fa";
import { MdAlternateEmail, MdOutlinePassword } from "react-icons/md";
import { PiTriangle } from "react-icons/pi";
import { ToastContainer } from "react-toastify";

import { IoIosLock, IoIosUnlock } from "react-icons/io";
import ToastHelper from "@/utils/toast_helper";

import { useRouter } from "next/navigation";

export default function LoginComponent() {
  const [visible, setVisible] = useState(false);
  const [successLogged, setSuccessLogged] = useState(false);

  const router = useRouter();

  const [state, action, isPending] = useActionState(loginClient, {
    errors: {},
  });

  // ? success message on registration validate
  useEffect(() => {
    if (state.success) {
      ToastHelper(state.message, true, false);
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setSuccessLogged(true);
      router.push("/");
    }
    if (!state.success) {
      ToastHelper(state.message, false, true);
    }
  }, [state]);

  // console.log("T H E  S T A TE ::: ", state);
  // console.log("T H E  S T A TE MESG ::: ", state.message);

  return (
    <div className="flex min-h-screen items-center  w-full bg-linear-to-br from-brow-bgLight-linT to-brow-bgLight-linF ">
      <ToastContainer />
      {/* //? logo section */}
      <div className="hidden min-h-screen lg:flex flex-2 justify-center items-center  relative bg-brow-main ">
        {/* //? logo */}
        <div className="h-[20vh] w-[20vw] z-10 ">
          <MyImage alt="" imgPath={images.tajirikaLogo} />
        </div>

        {/* //? linear bg */}
        <Deco />
      </div>

      <div className="w-full p-4 lg:flex flex-col gap-8 flex-1 justify-center items-center bg-linear-to-br from-brow-bgLight-linT to-brow-bgLight-linF lg:px-8 ">
        {/* //? icon */}
        <div className="w-full flex justify-center">
          <span>
            {" "}
            {successLogged ? (
              <IoIosUnlock className="text-9xl font-black text-brow-main " />
            ) : (
              <IoIosLock className="text-9xl font-black text-brow-main " />
            )}
          </span>
        </div>
        <div className="bg-white min-h-[20vh] flex flex-col relative p-2 w-full gap-10 pt-4 shadow-xl shadow-brow-main/15 rounded-sm ">
          {/* //? FORM */}

          <form
            action={action}
            className="w-full p-2 flex flex-col  justify-center items-center gap-10  "
          >
            {/* //? FORM */}
            <div className="w-full flex flex-col gap-2">
              {/* //? email */}
              <div className="w-full relative flex flex-col  items-center ">
                {/* prefix */}
                <div className="flex items-center gap-2 absolute left-2 top-3 ">
                  <MdAlternateEmail className="text-2xl text-[#111] " />
                  <div className="h-5 w-px bg-stone-400 " />
                </div>
                <input
                  type={"text"}
                  name={"email"}
                  placeholder={"exemple@gmail.com"}
                  className={`border outline-none focus:border focus:border-brow-main rounded-md text-lg md:text-xl p-2 w-full pl-12 
                     border-beige-dark
                     `}
                />
              </div>

              {/* //? password */}
              <div className="w-full relative flex flex-col  items-center ">
                {/* prefix */}
                <div className="flex items-center gap-2 absolute left-2 top-3 ">
                  <MdOutlinePassword className="text-2xl text-[#111] " />
                  <div className="h-5 w-px bg-stone-400 " />
                </div>
                <input
                  type={visible ? "text" : "password"}
                  name={"password"}
                  placeholder={"Entrez le mot secret"}
                  className={`border outline-none focus:border focus:border-brow-main rounded-md text-lg md:text-xl p-2 w-full pl-12 
                        border-beige-dark
                    `}
                />

                <div
                  onClick={() => setVisible(!visible)}
                  className=" absolute right-2 top-3 cursor-pointer "
                >
                  {visible ? (
                    <FaEyeSlash className="text-2xl text-[#111] " />
                  ) : (
                    <FaRegEye className="text-2xl text-[#111] " />
                  )}
                </div>
              </div>
              {/* //? DIVIDER */}
              <div className="w-full border-dashed my-3 border-beige-dark border " />
              <div className="w-full flex gap-2 items-center justify-end">
                <p className="text-brow-main text-lg font-semibold ">
                  Mot de pass oublié?
                </p>
              </div>
            </div>

            {/* //? BTN && REGISTER LINK */}
            <div className="w-full flex flex-col gap-2">
              <div className="w-full pr-2 pb-2 flex justify-center ">
                {isPending ? (
                  <div className="w-full flex justify-end items-center pr-2 ">
                    <div className="animate-spin rounded-full h-8 w-8 border-l-brow-lin border-l-3 border-b-3 border-b-brow-main " />
                  </div>
                ) : (
                  <button
                    type="submit"
                    // disabled
                    className="px-6 py-1.5 transition-all duration-300 rounded-sm bg-brow-main text-white text-lg flex items-center hover:opacity-80 cursor-pointer disabled:bg-gray-500 disabled:cursor-not-allowed "
                  >
                    <span>Se Connecter</span>
                  </button>
                )}
              </div>

              {/* //? LINK TO REGISTER PAGE */}
              <div className="w-full flex gap-2 text-sm font-semibold items-center justify-center md:text-lg ">
                <p className="text-[#111]  ">
                  N&apos;avez-vous pas encore un compte?
                </p>
                <Link href={"/register"} className="text-brow-main">
                  S&apos;inscrire
                </Link>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

function Deco() {
  return (
    <div className="min-h-screen flex items-end w-full absolute top-0 left-0 bg-linear-to-b from-transparent to-brow-lin ">
      <div className="h-[50vh] w-full flex justify-center items-center  overflow-hidden  ">
        <BsFillTriangleFill className="text-brow-main rotate-2 translate-y-[2vh] translate-x-[10vw] text-6xl " />
        <PiTriangle className="text-brow-main rotate-45 translate-y-[14vh] -translate-x-[1vw] text-6xl " />
        <BsFillTriangleFill className="text-brow-main rotate-20 -translate-y-[10vh] -translate-x-[10vw] text-6xl " />
        <BsFillTriangleFill className="text-brow-main -rotate-20 -translate-y-[10vh] translate-x-[6vw] text-6xl " />
        <BsFillTriangleFill className="text-brow-main translate-y-[20vh] translate-x-[5vw] -rotate-22 text-6xl " />
        <BsFillTriangleFill className="text-brow-main rotate-60 translate-x-[12vw] -translate-y-[10vh] text-6xl " />
        <BsFillTriangleFill className="text-brow-main translate-x-[25vw] -translate-y-[2vh] rotate-36 text-6xl " />
        <PiTriangle className="text-brow-main -rotate-17 translate-y-[14vh] -translate-x-[30vw] text-6xl " />
        <BsFillTriangleFill className="text-brow-main translate-y-[10vh] translate-x-[5vw] rotate-18 text-6xl " />
        <PiTriangle className="text-brow-main translate-y-[15vh] translate-x-[12vw] -rotate-5 text-6xl " />
        <BsFillTriangleFill className="text-brow-main translate-y-[18vh] translate-x-[18vw] -rotate-18 text-6xl " />
        <PiTriangle className="text-brow-main translate-y-[6vh] -translate-x-[16vw] -rotate-18 text-6xl " />
        <PiTriangle className="text-brow-main translate-y-[6vh] translate-x-[16vw] rotate-18 text-6xl " />
        <BsFillTriangleFill className="text-brow-main -rotate-2 translate-x-[12vw] -translate-y-[16vh] text-6xl " />
        <BsFillTriangleFill className="text-brow-main -translate-x-[50vh] -translate-y-[16vw] -rotate-45 text-6xl " />
        <PiTriangle className="text-brow-main -translate-x-[10vw] -translate-y-[10vh] rotate-10 text-6xl " />
        <BsFillTriangleFill className="text-brow-main -translate-x-[45vw] -translate-y-[4vh] rotate-16 text-6xl " />
        <PiTriangle className="text-brow-main -translate-x-[45vw] -translate-y-[16vh] -rotate-16 text-6xl " />
      </div>
    </div>
  );
}
